export default {
  hex: {
    HIGHLIGHT_COLOR: 'fffae5',
    BLACK: '0a0a0a',
    BLUE_GRAY: 'eaf0f2',
    DANGER: 'ee3123',
    DARK_GRAY: '1a1a1a',
    DEFAULT: '4185db',
    FASTMODEL_GRAY: '1a1a1a',
    FASTMODEL_RED: 'ee3123',
    LIGHT_BLUE: '0Cb5eb',
    LIGHTEST_GRAY: 'f2f2f2',
    LIGHT_GRAY: 'c4c4c4',
    GRAY_BACKGROUND: 'f9f9f9',
    MEDIUM_GRAY: '898989',
    MINT_GREEN: '9be8b8',
    RICH_ORANGE: 'e65d1d',
    ORANGE: 'ff8139',
    PRIMARY: '4185db',
    PURPLE: 'b79deb',
    SECONDARY: '1a1a1a',
    SUCCESS: '4ebe7c',
    THIRD: 'ee3123',
    HEADER_BLUE: '3874c1',
    WARNING: 'ffd13f',
    WHITE: 'fff',
    YELLOW: 'ffd13f',

    FLAGGED_TOURNEY_EVENT: '3772BC',
    FLAGGED_SEASON_EVENT: '00B4EE',
    UNFLAGGED_TOURNEY_EVENT: 'c4c4c4',
    UNFLAGGED_SEASON_EVENT: 'eaf0f2',
  },
  rgb: {
    CONTRAST_COLORS: [
      '166,206,227',
      '31,120,180',
      '178,223,138',
      '51,160,44',
      '251,154,153',
      '227,26,28',
      '253,191,111',
      '255,127,0',
      '202,178,214',
      '106,61,154',
      '255,255,153',
      '177,89,40'
    ]
  }
};



// WEBPACK FOOTER //
// ./src/js/util/constants/colors.js